import { useState, useEffect, useCallback, useRef } from 'preact/hooks';
import { SITE_URL } from "../config";
import { campaignLogger, loadAnal } from './utility';
import Header from './header';
import Footer from './footer';
import YoutubePopup from './youtubepopup';
import ChatPopup from './chatpopup';
import CookiePopup from './cookiepopup';
import AppRouter from "../appRouter";

export default function App() {
	const [user, setUser] = useState(null);
	const [cookiesClosed, setCookiesClosed] = useState(false);
	const [isStudio, setIsStudio] = useState(false);
	const [currentUrlClass, setCurrentUrlClass] = useState("");
	const [ytData, setYtData] = useState(null);
	const [chatData, setChatData] = useState(null);

	const appWrpEl = useRef(null);
	const checkLoggedInPromise = useRef(null);

	const checkLoggedIn = useCallback(() => {
		if (checkLoggedInPromise.current === null) {
			checkLoggedInPromise.current = new Promise((resolve, reject) => {
				if (typeof window !== 'undefined') {
					appWrpEl.current = document.getElementById('appWrp');
					let xmlhttp = new XMLHttpRequest();
					xmlhttp.withCredentials = true;
					xmlhttp.onreadystatechange = function () {
						if (this.readyState === 4 && this.status === 200) {
							let res = JSON.parse(this.responseText);
							if (res.s) {
								setUser(res.u);
								resolve(true);
							} else {
								resolve(false);
							}
						}
					}
					xmlhttp.open('GET', SITE_URL + 'auth/get-current-user', true);
					xmlhttp.send();
				} else {
					reject();
				}
			});
		}
		return checkLoggedInPromise.current;
	}, []);

	const cookieAcceptedCB = useCallback(() => {
		checkLoggedIn();
		loadAnal();
		campaignLogger();
	}, [checkLoggedIn]);

	const checkIsStudio = useCallback(() => {
		/*if (typeof window !== 'undefined') {
			setIsStudio(window.location.href.indexOf('chatbot-studio') !== -1);
		}*/
	}, []);

	const handleRoute = useCallback((e) => {
		setCurrentUrlClass(e.url.replace("/", ""));
		if (typeof window !== 'undefined') {
			setTimeout(() => {
				if (e.url === '/digitaltwin' || e.url === '/' ||
				e.url === '/products/schools-assistant' ||
				e.url === '/products/restaurant-assistant' ||
				e.url === '/products/municipal-assistant') {
					let querlyEl = document.getElementById("querloEmbd");
					if (querlyEl) querlyEl.style.display = "none";
				} else {
					let querlyEl = document.getElementById("querloEmbd");
					if (querlyEl) querlyEl.style.display = "block";
				}
			}, 301);
		}

		checkIsStudio();

		if (typeof window !== 'undefined') window.scrollTo(0, 0);
		if (process.env.NODE_ENV === 'production') {
			if (typeof gtag !== 'undefined') {
				gtag('config', 'UA-6924977-74', {
					page_location: window.location.origin + e.url
				});
			}
		}

		if (appWrpEl.current) appWrpEl.current.classList.remove('openMenu');
	}, [checkIsStudio]);

	const headerCB = useCallback((e) => {
		e.preventDefault();
		if (appWrpEl.current) {
			if (appWrpEl.current.classList.contains('openMenu'))
				appWrpEl.current.classList.remove('openMenu');
			else
				appWrpEl.current.classList.add('openMenu');
		}
	}, []);

	const closePopup = useCallback(() => {
		setYtData(null);
	}, []);

	const acceptCookies = useCallback((accept) => {
		if (typeof window !== 'undefined') {
			if (accept) {
				localStorage.setItem('cookieaccept', true);
				cookieAcceptedCB();
			}
		}
		setCookiesClosed(true);
	}, [cookieAcceptedCB]);

	const closeChat = useCallback(() => {
		console.log('closing chat');
		setChatData(null);
	}, []);

	const handleYTRequest = useCallback((id) => {
		setYtData(id);
	}, []);

	const handleChatRequest = useCallback((id) => {
		setChatData(id);
	}, []);

	useEffect(() => {
		checkIsStudio();
		appWrpEl.current = document.getElementById('appWrp');
		if (typeof window !== 'undefined') {
			if (localStorage.getItem('cookieaccept')) {
				setCookiesClosed(true);
				cookieAcceptedCB();
			}
		}
	}, [checkIsStudio, cookieAcceptedCB]);

	return (
		<div id="appWrp" className={currentUrlClass}>
			<Header cb={headerCB} u={user} isStudio={isStudio} />
			<main>
				<AppRouter
					handleRoute={handleRoute}
					handleYTRequest={handleYTRequest}
					checkLoggedIn={checkLoggedIn}
					handleChatRequest={handleChatRequest}
				/>
			</main>
			<Footer />
			{ytData ? <YoutubePopup data={ytData} cb={closePopup} /> : ''}
			{cookiesClosed ? '' : <CookiePopup cb={acceptCookies} />}
			{chatData ? <ChatPopup data={chatData} cb={closeChat} /> : ''}
		</div>
	);
}
